<script>
import styled from 'vue-styled-components';

const CookieBannerOptionsList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

export default CookieBannerOptionsList;
</script>